import axios from "axios";
import { ENVIRONMENT } from "../constants/env/internalService.constants";
import { getFromLocal } from "./storage.util";

export const objectCopy = (obj: any) => {
  return JSON.parse(JSON.stringify(obj));
};

export const getErrorMessage = (error: unknown) => {
  let message = "Something went wrong. Please try again.";

  // Handle error if it's a simple string
  if (typeof error === 'string') {
    message = error;
  }
   
  if (axios.isAxiosError(error)) {
    if (error.response?.data?.message) {
      message = error.response?.data?.message;
    } else if (error.response?.data?.msg) {
      message = error.response?.data?.msg;
    }
  }
  return message;
  // if (error instanceof Error) return error.message;
  // return String(error);
};

export const getReferrer = () => document.referrer;

export const getScreenWidth = () => window.screen.width;

export const getURLParams = () => getFromLocal("utmFields");

export const getCurrentURL = () => window.location.href;

export const getCDNURL: () => string = () => {
  return ENVIRONMENT === "production"
    ? "https://d502jbuhuh9wk.cloudfront.net/"
    : "https://d1lhfd3j3c8egz.cloudfront.net/";
};

export const getCountryLocale = (countryCode: string | undefined | null): string => {
  // Always return 'en' - no country-based locale redirection
  return 'en';
};
